import type { Option } from '@/modules/common/types/option.type.ts';

export type DirectoryField = 'segment' | 'region';

export type DirectoryFieldState<T extends Option<number> = Option<number>> = {
  value: T | null;
  required: boolean;
  placeholderKey: string;
};

export function resolveDirectoryFieldState<T extends Option<number>>(
  field: DirectoryField,
  options: T[],
  current: T | null
): DirectoryFieldState<T> {
  const count = options.length;
  const defaultPlaceholder = field === 'segment' ? 'counterparty.field.segment' : 'counterparty.field.region';

  if (count === 0) {
    return {
      value: null,
      required: true,
      placeholderKey: `counterparty.master.steps.manager.field.${field}.add`,
    };
  }

  if (count === 1) {
    const only = options[0]!;

    return {
      value: current?.code === only.code ? current : only,
      required: true,
      placeholderKey: defaultPlaceholder,
    };
  }

  const value = current && options.some((option) => option.code === current.code) ? current : null;

  return {
    value,
    required: true,
    placeholderKey: `counterparty.master.steps.manager.field.${field}.select`,
  };
}
